import { Api } from '../api';
import { cards } from '../endpoints';
import type { CardEntity } from './models';

export class CardApi extends Api {
  static getCardsByAccount = (accountId: string, signal?: AbortSignal) => this.get<CardEntity[]>(cards.getAccount(accountId), { signal });

  static activateCard = (cardId: string, signal?: AbortSignal) => this.post<CardEntity[]>(cards.activation(cardId), { signal });

  static replaceCard = (cardId: string, signal?: AbortSignal) => this.post<CardEntity[]>(cards.replaceCard(cardId), { signal });

  static reprintPin = (cardId: string, signal?: AbortSignal) => this.post<CardEntity[]>(cards.reprintPin(cardId), { signal });

  static blockCard = (cardId: string, signal?: AbortSignal) => this.put<CardEntity[]>(cards.blockCard(cardId), { signal });

  static unblockCard = (cardId: string, signal?: AbortSignal) => this.put<CardEntity[]>(cards.unblockCard(cardId), { signal });
}
